import React from "react";
import { OutPortal } from "react-reverse-portal";

const RenderedOutPortals = ({ portalRefs }) => {
  let renderedOutPortals = [];

  portalRefs.forEach((ref, index) => {
    renderedOutPortals.push(<OutPortal key={index} node={ref} />);
  });

  return renderedOutPortals;
};

export default RenderedOutPortals;
